import React from 'react';
import classNames from 'classnames';

import VideoMediafilesPreviewItemSkeleton from 'application/components/VideoMediafilePreviewItemSkeleton';
import styles from './index.module.scss';
import VideoMediafilePreviewItemContent from './VideoMediafileItemContent';
import { IVideoMediafile } from '../../types';
import { DEFAULT_IMAGE_DURATION } from '../../consts';

export type StreamPreviewItemProps = {
  file?: IVideoMediafile;
  className?: string;
  actionText?: string;
  actionHandler?: () => void;
};

const VideoStreamPreviewItem: React.FC<StreamPreviewItemProps> = ({ file, className, actionText, actionHandler }) => {
  const renderItem = () => {
    if (file) {
      return (
        <VideoMediafilePreviewItemContent
          imgLink={file.previewUrl}
          title={file.title}
          uploading={file.uploading}
          duration={file.duration || DEFAULT_IMAGE_DURATION}
          actionHandler={actionHandler}
          actionText={actionText}
          extension={file.sourcefiles ? file?.sourcefiles[0]?.extension : undefined}
        />
      );
    }

    return <VideoMediafilesPreviewItemSkeleton />;
  };

  return <div className={classNames(styles.StreamPreviewItem, className)}>{renderItem()}</div>;
};

export default VideoStreamPreviewItem;
